import { CgSoftwareDownload } from 'react-icons/cg';
import { StyledButton } from '@app/components/button/Button';
import type { BillingReportTableRow } from '@app/services/billingReports.types';

type ExportBtnProps = {
    tableData: BillingReportTableRow[];
    currencies: string[];
    dates: { start: string; end: string };
};

const handleExport = (
    tableData: BillingReportTableRow[],
    currencies: string[],
    dates: { start: string; end: string }
) => {
    const headers = ['Category', 'Channel Partner', 'Amount', 'Unit', ...currencies].join(',');
    const extractRowData = (row: BillingReportTableRow) => {
        const valueHeaders = ['category', 'channel_partner', 'amount', 'unit', ...currencies];
        return valueHeaders
            .map((header) => {
                const value = row[header];
                if (value) {
                    return value;
                } else if (header === row.currency) {
                    return row.total;
                } else {
                    return '';
                }
            })
            .join(',');
    };
    const rows = tableData.map((row) => extractRowData(row));
    const csvContent = [headers, ...rows].join('\r\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download =
        `${dates.start.split(' ')[0]}_to_${dates.end.split(' ')[0]}` + '_billing-report.csv';
    a.click();
    URL.revokeObjectURL(url);
};

const ExportBtn = ({ tableData, currencies, dates }: ExportBtnProps) => {
    return (
        <StyledButton
            type="primary"
            icon={<CgSoftwareDownload size={20} />}
            onClick={() => handleExport(tableData, currencies, dates)}
            disabled={!tableData.length}>
            Export CSV
        </StyledButton>
    );
};

export default ExportBtn;
